export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-drive-b4ab317cb8841b0f7ba953653bad9f87.svg";